import { Routes, Route } from 'react-router-dom';
import SignupOrLogin from '@pages/SignupOrLogin';
import NotFound from '@pages/NotFound';
import Setup from '@pages/Setup';
import Authenticate from '@pages/Authenticate';
// eslint-disable-next-line import/no-unresolved
import Home from '@pages/Home';
import './App.css';
// import Application from '@pages/Application';
// import BuyerReturnAssurance from '@pages/__Application/BuyerReturnAssurance';
// import BRAStep1 from '@pages/Application/BuyerReturnAssurance/Step1';
// import BRAStep2 from '@pages/Application/BuyerReturnAssurance/Step2';
// import BRAStep3 from '@pages/Application/BuyerReturnAssurance/Step3';
import { AuthControl, RouterControl } from '@hooks/useAuthContext';
import ConnectionPopup from '@pages/ConnectionPopup';
import Transactions from '@pages/Transactions';
import Billing from '@pages/Billing';
import Policies from '@pages/Policies';
import Products from '@pages/Products';
import Dashboard from '@pages/Dashboard';
import PolicyDetail from '@pages/PolicyDetail';
import OnboardingConnect from '@pages/Onboarding-connect';
import OnboardingSurvey from '@pages/Onboarding-survey';
import OnboardingSelect from '@pages/Onboarding-select';
import { ApplicationProvider } from '@hooks/useApplicationContext';
import { ProductsProvider } from '@hooks/useProductsContext';
import { ConnectionProvider } from '@hooks/useConnectionContext';
import { SettingsProvider } from '@hooks/useSettings';
// import Test from '@pages/Test';
import OrgSettings from './pages/OrgSettings';
import { EddApplication } from './pages/EddApplication';
import Layout from './pages/Layout';
// import ApplicationLayout from './pages/Application/Layout';
import GDD from './pages/Application/GDD';
import GDDReview from './pages/Application/GDD-Review';
import ConnectionLandPage from './pages/ConnectionLandPage';
import RASettings from './pages/RASettings';
import BPSettings from './pages/BPSettings';
import RAApplication from './pages/Application/RA';
import BPApplication from './pages/Application/BP';
import BGApplication from './pages/Application/BG';
import EWApplication from './pages/Application/EW';
import ODGApplication from './pages/Application/ODG';
import AccountSettings from './pages/AccountSettings';
import BillingV2 from './pages/Billing-V2';

function App() {
  return (
    <div className="App">
      <Routes>
        {
          ['*', 'onboarding', 'onboarding/*', 'gdd/application/*'].map((path) => <Route key={path} path={path} element={<NotFound />} />)
        }
        <Route
          path="landing"
          element={(<AuthControl><ConnectionLandPage /></AuthControl>)}
        />
        <Route path="/" element={<RouterControl><ConnectionProvider><ProductsProvider><SettingsProvider><Layout /></SettingsProvider></ProductsProvider></ConnectionProvider></RouterControl>}>
          <Route index element={<Dashboard />} />
          <Route path="policies" element={<Policies />} />
          <Route path="policies/:policyId" element={<PolicyDetail />} />
          <Route path="transactions/*" element={<Transactions />} />
          <Route path="billing/*" element={<Billing />} />
          <Route path="billing-v2/*" element={<BillingV2 />} />
          <Route path="products" element={<Products />} />
          <Route path="oldhome" element={<Home />} />
          <Route path="organization-settings" element={<OrgSettings />} />
          <Route path="account-settings" element={<AccountSettings />} />

        </Route>
        {
          ['login', 'sinup-or-login'].map((path) => <Route key={path} path={path} element={<SignupOrLogin />} />)
        }
        <Route path="onboarding" element={<RouterControl><ConnectionProvider><ProductsProvider><ApplicationProvider><Layout options={{ showNavItems: false, showCircleBackground: true }} /></ApplicationProvider></ProductsProvider></ConnectionProvider></RouterControl>}>
          <Route path="connect" element={<OnboardingConnect />} />
          <Route path="survey" element={<OnboardingSurvey />} />
          <Route path="select" element={<OnboardingSelect />} />
        </Route>
        <Route path="onboarding/setup" element={<Setup />} />
        <Route path="connect-store" element={<ConnectionPopup />} />
        <Route path="authenticate" element={<Authenticate />} />
        <Route path="gdd/application">
          <Route index element={<GDD />} />
          <Route path="review" element={<GDDReview />} />
        </Route>
        <Route
          path="ra/application/*"
          element={(
            <ConnectionProvider>
              <RAApplication />
            </ConnectionProvider>
          )}
        >
        </Route>

        <Route
          path="bp/application/*"
          element={(
            <ConnectionProvider>
              <BPApplication />
            </ConnectionProvider>
          )}
        >
        </Route>
        <Route
          path="bg/application/*"
          element={(
            <ConnectionProvider>
              <BGApplication />
            </ConnectionProvider>
          )}
        >
        </Route>
        <Route
          path="ew/application/*"
          element={(
            <ConnectionProvider>
              <EWApplication />
            </ConnectionProvider>
          )}
        >
        </Route>
        <Route
          path="odg/application/*"
          element={(
            <ConnectionProvider>
              <ODGApplication />
            </ConnectionProvider>
          )}
        />
        {/* <Route
          path="/"
          element={(
            <ConnectionProvider>
              <ApplicationProvider></ApplicationProvider>
            </ConnectionProvider>
          )}
        >

          <Route path="odg/application" element={<EddApplication />} />
        </Route> */}
        <Route
          path="edd/application/*"
          element={(
            <ConnectionProvider>
              <ApplicationProvider><EddApplication /></ApplicationProvider>
            </ConnectionProvider>
          )}
        />
        <Route
          path="ra/settings"
          element={(
            <ConnectionProvider>
              <RASettings />
            </ConnectionProvider>
          )}
        />
        <Route
          path="bp/settings"
          element={(
            <ConnectionProvider>
              <BPSettings />
            </ConnectionProvider>
          )}
        />
        <Route
          path="reset-password"
          element={(<SignupOrLogin />)}
        />
        {/* <Route
          path="test"
          element={(<Test />)}
        /> */}
      </Routes>
    </div>
  );
}

export default App;
